// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Autocomplete__autocompleteContainer___DQL7f {
  position: relative;
  width: 100%;
}

.Autocomplete__autoCompleteInputContainer___slBqa {
  display: flex;
}

.Autocomplete__autoCompleteInput___GZ_Oz {
  background: white;
  box-sizing: border-box;
  border-radius: 3px;
  background-color: #fff;
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  align-items: center;
  margin-right: -2px;
  /* padding-left: 8px; */
  position: relative;
}

.Autocomplete__autoCompleteInput___GZ_Oz .Autocomplete__iconSearch___pFEHk {
    position: absolute;
    right: 6px;
  }

.Autocomplete__autoCompleteInput___GZ_Oz input {
    height: 42px !important;
    background: transparent;
    border: 1px solid rgba(195, 195, 195, 0.45);

    flex-grow: 1;
    flex-shrink: 1;
    padding-right: 38px;
    padding-left: 10px;
    height: 100%;
    width: 100%;
    transition: all 0.25s;
    margin-right: 0 !important;
    font-weight: 500;
  }

.Autocomplete__autoCompleteInput___GZ_Oz input::placeholder {
    opacity: 0.5;
  }

.Autocomplete__autoCompleteInput___GZ_Oz input:focus {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]} !important;
    border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]} !important;
    outline: none !important;
  }

.Autocomplete__autoCompleteInput___GZ_Oz input:not(:placeholder-shown) {
    font-weight: 700;
  }
autoCompleteInput:focus {
  background-color: white !important;
}
.Autocomplete__autoCompleteInputDisabled___RYJLR {
  background: #e1e1e178 !important;
  box-sizing: border-box;
  height: 42px;
  border: 1px solid rgba(195, 195, 195, 0.45);
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  background-color: #fff;
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  align-items: center;
  margin-right: -2px;
  padding-left: 8px;
}
.Autocomplete__autoCompleteInputDisabled___RYJLR input {
    background: transparent;
    border: none;
    flex-grow: 1;
    flex-shrink: 1;
    margin-left: 8px;
  }

.Autocomplete__autoCompleteInputBtn___dwqOf {
  font-size: 15px;
  font-weight: 700;
  width: 218px;
  height: 51px;
  border-radius: 3px;
  background-color: #376ea1;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.02);
  color: white;
  border: none;
}

.Autocomplete__autocomplete_resultContainer___Gqn3N {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  width: 100%;
  /* background: white; */
  z-index: 100;
}

.Autocomplete__autoCompleteItems_clearIcon___KXWXo {
  margin: 0 10px;
  width: 20px;
  height: 20px;
  color: #ccc;
  cursor: pointer;
  position: absolute;
  right: -4px;
  top: 16px;
}

.Autocomplete__textarea___sYu5R {
  background-color: initial;
  min-height: 50px !important;
  min-width: 100%;
  resize: none;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./universal/components/Autocomplete/Autocomplete.css"],"names":[],"mappings":"AAIA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AAgCpB;;AA/BE;IACE,kBAAkB;IAClB,UAAU;EACZ;;AACA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,2CAA2C;;IAE3C,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,0BAA0B;IAC1B,gBAAgB;EAClB;;AACA;IACE,YAAY;EACd;;AAEA;IACE,mEAAkC;IAClC,yEAAmC;IACnC,wBAAwB;EAC1B;;AACA;IACE,gBAAgB;EAClB;AAEF;EACE,kCAAkC;AACpC;AACA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,YAAY;EACZ,2CAA2C;EAC3C,2BAA2B;EAC3B,8BAA8B;EAC9B,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AASnB;AAPE;IACE,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,gBAAgB;EAClB;;AAGF;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,2CAA2C;EAC3C,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EAEE,yBAAyB;EACzB,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":["@value helpers: 'styles/helpers.css';\n@value colors: 'styles/colors.css';\n@value gtBlue, gtBlueLight from colors;\n\n.autocompleteContainer {\n  position: relative;\n  width: 100%;\n}\n\n.autoCompleteInputContainer {\n  display: flex;\n}\n\n.autoCompleteInput {\n  background: white;\n  box-sizing: border-box;\n  border-radius: 3px;\n  background-color: #fff;\n  display: flex;\n  flex-grow: 1;\n  flex-shrink: 1;\n  align-items: center;\n  margin-right: -2px;\n  /* padding-left: 8px; */\n  position: relative;\n  .iconSearch {\n    position: absolute;\n    right: 6px;\n  }\n  input {\n    height: 42px !important;\n    background: transparent;\n    border: 1px solid rgba(195, 195, 195, 0.45);\n\n    flex-grow: 1;\n    flex-shrink: 1;\n    padding-right: 38px;\n    padding-left: 10px;\n    height: 100%;\n    width: 100%;\n    transition: all 0.25s;\n    margin-right: 0 !important;\n    font-weight: 500;\n  }\n  input::placeholder {\n    opacity: 0.5;\n  }\n\n  input:focus {\n    background: gtBlueLight !important;\n    border: 1px solid gtBlue !important;\n    outline: none !important;\n  }\n  input:not(:placeholder-shown) {\n    font-weight: 700;\n  }\n}\nautoCompleteInput:focus {\n  background-color: white !important;\n}\n.autoCompleteInputDisabled {\n  background: #e1e1e178 !important;\n  box-sizing: border-box;\n  height: 42px;\n  border: 1px solid rgba(195, 195, 195, 0.45);\n  border-top-left-radius: 3px;\n  border-bottom-left-radius: 3px;\n  background-color: #fff;\n  display: flex;\n  flex-grow: 1;\n  flex-shrink: 1;\n  align-items: center;\n  margin-right: -2px;\n  padding-left: 8px;\n\n  input {\n    background: transparent;\n    border: none;\n    flex-grow: 1;\n    flex-shrink: 1;\n    margin-left: 8px;\n  }\n}\n\n.autoCompleteInputBtn {\n  font-size: 15px;\n  font-weight: 700;\n  width: 218px;\n  height: 51px;\n  border-radius: 3px;\n  background-color: #376ea1;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.02);\n  color: white;\n  border: none;\n}\n\n.autocomplete_resultContainer {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  width: 100%;\n  /* background: white; */\n  z-index: 100;\n}\n\n.autoCompleteItems_clearIcon {\n  margin: 0 10px;\n  width: 20px;\n  height: 20px;\n  color: #ccc;\n  cursor: pointer;\n  position: absolute;\n  right: -4px;\n  top: 16px;\n}\n\n.textarea {\n  composes: textarea from helpers;\n  background-color: initial;\n  min-height: 50px !important;\n  min-width: 100%;\n  resize: none;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `'styles/helpers.css'`,
	"colors": `'styles/colors.css'`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"gtBlueLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]}`,
	"autocompleteContainer": `Autocomplete__autocompleteContainer___DQL7f`,
	"autoCompleteInputContainer": `Autocomplete__autoCompleteInputContainer___slBqa`,
	"autoCompleteInput": `Autocomplete__autoCompleteInput___GZ_Oz`,
	"iconSearch": `Autocomplete__iconSearch___pFEHk`,
	"autoCompleteInputDisabled": `Autocomplete__autoCompleteInputDisabled___RYJLR`,
	"autoCompleteInputBtn": `Autocomplete__autoCompleteInputBtn___dwqOf`,
	"autocomplete_resultContainer": `Autocomplete__autocomplete_resultContainer___Gqn3N`,
	"autoCompleteItems_clearIcon": `Autocomplete__autoCompleteItems_clearIcon___KXWXo`,
	"textarea": `Autocomplete__textarea___sYu5R ${___CSS_LOADER_ICSS_IMPORT_1___.locals["textarea"]}`
};
export default ___CSS_LOADER_EXPORT___;
